export const LOAD_SEARCH_CHANGE_TRACKING = {
  searchDate: {
    source: 'load_search.search.date',
    id: 12431,
  },
  searchPerson: {
    source: 'load_search.search.person',
    id: 12432,
  },
  searchCustomer: {
    source: 'load_search.search.customer',
    id: 12433,
  },
  searchCarrier: {
    source: 'load_search.search.carrier',
    id: 12434,
  },
  searchOriginDestination: {
    source: 'load_search.search.origin_destination',
    id: 12435,
  },
  searchStatus: {
    source: 'load_search.search.status',
    id: 12436,
  },
} as const;
